import axios from 'axios'
import { BUSCAR_ULTIMOS_HISTORICOS_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarUltimosHistoricosUsuario (usuarioId, empresaId) {
  let url = `${URL}/usuarios/${usuarioId}/empresa/${empresaId}/historicos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ULTIMOS_HISTORICOS_USUARIO,
        payload: response

      })
  );
}
